import { render, staticRenderFns } from "./my-customer.vue?vue&type=template&id=fcd18e86&scoped=true"
import script from "./my-customer.vue?vue&type=script&lang=js"
export * from "./my-customer.vue?vue&type=script&lang=js"
import style0 from "./my-customer.vue?vue&type=style&index=0&id=fcd18e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd18e86",
  null
  
)

export default component.exports